export const pages = [
  { name: "Home", path: "/" },
  // { name: "Locations", path: "/locations" },
  // { name: "Packages", path: "/packages" },
  { name: "Products", path: "/products" },
  { name: "Contact Us", path: "/contact" },
  { name: "About Us", path: "/about" },
];
